export default __webpack_public_path__ + "9a1d6d7e93387f6ac0566bd8f9e8a838.svg";